module.exports = __webpack_public_path__ + "static/media/dansere.68bbcf4d.jpg";